import styled from 'styled-components'

export const ModalSubTitle = styled.p`
  font-size: 14px;
  margin: 0 0 20px;
  text-align: center;
`
